// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingStats_container__na_gS","title":"LandingStats_title__U_URJ","reportCards":"LandingStats_reportCards__cdjvC","reportCard":"LandingStats_reportCard__5wnbb"};